import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { PostAppLogin } from '../utils/apis';
import { hasValue, CreateLoginSession } from '../utils/common_functions';
import { Spinner } from 'reactstrap';

const ValidateAppLogin = () => {
    const [searchParams] = useSearchParams();

    const CheckAppLogin = async () => {
        try {
            let post_data = searchParams.get('data');

            let obj = { data: post_data }
            let resp = await PostAppLogin(obj);
            CreateLoginSession(resp.data.device);

            setTimeout(() => {
                window.location.href = '/features?pay_feature=' + resp.data.feature;
            }, 2000)
        }
        catch (error) {
            window.location.href = '/login';
        }
    }

    useEffect(() => {
        if (hasValue(searchParams.get('data'))) {
            CheckAppLogin();
        }
        else {
            window.location.href = '/login';
        }
    }, []);

    return (
        <div className="login-wrapper">
            <div className="mb-3 text-center">
                <Spinner color="primary" />
            </div>
        </div>
    );
}

export default ValidateAppLogin;